import React from "react";
import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <>
      {/* contact */}
      <section className="contact__area-6 pt-150 pb-150">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="row">
                <div className="col-lg-6">
                  <div className="contact__item">
                    <i className="fa-solid fa-location-dot" />
                    <h4 className="title">Adres</h4>
                    <p>Kanlıca mahallesi Hacı Muhittin sokak No 10 Beykoz/ Istanbul</p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="contact__item">
                    <i className="fa-solid fa-share" />
                    <h4 className="title">Sosyal Medya</h4>
                    <p>
                      Twitter/@securitr_ <br />
                      Instagram/securitr.as
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="contact__item">
                    <i className="fa-solid fa-phone" />
                    <h4 className="title">Telefon</h4>
                    <p>
                    0544 915 28 28 
                      
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="contact__item">
                    <i className="fa-solid fa-envelope" />
                    <h4 className="title">Email</h4>
                    <Link to="mailto:info@securitr.com.tr">
                      info@securitr.com.tr
                    </Link>
                    
                  </div>
                </div>
                
              </div>
            </div>
            <div className="col-lg-6">
              <iframe
                title="securitr"
                className="w-100"
                height={500}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3006.5775916294356!2d29.06415397626519!3d41.10007507133791!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caca6ad13a55df%3A0x64c1195c87c1fed2!2sKanl%C4%B1ca%2C%20Hac%C4%B1%20Muhittin%20Sk.%20No%3A10%2C%2034810%20Beykoz%2F%C4%B0stanbul!5e0!3m2!1str!2str!4v1706080767300!5m2!1str!2str"
              />
            </div>
          </div>
          <div className="blog__form">
            <span className="blog__form-title">Bizimle iletişime geçin</span>
            <form action="https://formsubmit.co/info@securitr.com.tr">
              <div className="row">
                <div className="col-md-6">
                  <input
                    type="text"
                    name="user_name"
                    id="Name"
                    placeholder="Ad Soyad"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="email"
                    name="user_email"
                    id="E-mail"
                    placeholder="E-mail"
                    required
                  />
                </div>
                <div className="col-md-12">
                  <textarea
                    name="msg"
                    id="msg"
                    placeholder="Mesajınız"
                    defaultValue={""}
                    required
                  />
                </div>
                <div className="contact__submitwrap">
                  <button
                    className="contact__submit btn-rollover"
                    type="submit"
                  >
                    Gönder <i className="fa-solid fa-arrow-right" />
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
      {/* /iletisim */}
    </>
  );
};

export default Contact;
